import React, { useEffect } from "react";
import { useState } from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import "./Dashboard.css";
import OrderSummary from "../../../components/DashboardComponents/OrderSummary/OrderSummary";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Wrapper from "../../../components/UI/Wrapper";
import PieChartComponent from "../../../components/DashboardComponents/PieChartComponent/PieChartComponent";
import PieChartComponentLeadStage from "../../../components/DashboardComponents/PieChartComponent/PieChartComponentLeadStage";
// import SearchIcon from "@mui/icons-material/Search";
import LeadData from "../../../components/DashboardComponents/LeadData/LeadData";
import MapComponent from "../../../components/DashboardComponents/MapComponent/MapComponent";
import Graph from "../../../components/DashboardComponents/Graph/Graph";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import icon_user from "../../../Icons/icon_user.png";
import axios from "axios";

import PieChartConversions from "../../../components/DashboardComponents/PieChartComponent/PieChartConversions";
import PieChartRevenueAchieved from "../../../components/DashboardComponents/PieChartComponent/PieChartRevenueAchieved";
import PieChartLeadAchieved from "../../../components/DashboardComponents/PieChartComponent/PieChartLeadAchieved";

const Dashboard = () => {
  const [isOpen, setIsOpen] = useState(false);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [leadDataResponse, setLeadDataResponse] = useState([]);

  const [leadSources, setLeadSources] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isLeadStagePickerOpen, setLeadStagePickerOpen] = useState(false);
  const [isLeadSourcePickerOpen, setLeadSourcePickerOpen] = useState(false);

  const [isUserLeadDataOpen, setIsUserLeadDataOpen] = useState(false);

  const [dateRange, setDateRange] = useState("Select Date Range");
  const [dateRangeSource, setDateRangeSource] = useState("Select Date Range");

  const [dateRangeStage, setDateRangeStage] = useState("Select Date Range");
  const [dateRangeUser, setDateRangeUser] = useState("Select Date Range");
  const [selectionRange, setSelectionRange] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  }); // Initially null

  const [filterData, setFilterData] = useState("0"); // Default to 'All'
  const [filteredResults, setFilteredResults] = useState([]);
  const [colors, setColors] = useState({});
  const [colorsSource, setColorsSource] = useState({});
  const [colorsUsers, setColorsUsers] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalLeadSource, setTotalLeadSource] = useState(0);
  const [totalAssignedLeads, setTotalAssignedLeads] = useState(0);
  const [totalLeadUpdate, setTotalLeadUpdate] = useState(0);
  const [totalTargetAchieved, setTotalTargetAchieved] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [filterUserData, setFilterUserData] = useState("1");
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalConversion, setTotalConversion] = useState(0);
  const [totalRevConversion, setTotalRevConversion] = useState(0);
  const [totalQuotationAmount,setTotalQuotationAmount] = useState(0);
  const [totalTokenAmount,setTotalTokenAmount] = useState(0);
  const [totalSalesTarget,setTotalSalesTarget] = useState(0);
  const [totalRevenueAchieved,setTotalRevenueAchieved] = useState(0);
  const [totalLeadConversionTarget,setTotalLeadConversionTarget] = useState(0);
  const [totalLeadsAchieved,setTotalLeadsAchieved] = useState(0);
  const [totalLeadAchievedPer,setTotalLeadAchievedPer] = useState(0);
  const [usersLeadCount, setUsersLeadCount] = useState([]);
   

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {

      axios
        .get(`${baseAPI}userget/GetDashboardLeadSource?startDate=&enddate=`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response && response.data && response.data.data) {
            setLeadSources(response.data.data);
            setTotalLeadSource(response.data.totalRecords);
            setColorsSource(generateColorsSource(response.data.data));
            setSelectionRangeSource({
              startDate: new Date(),
              endDate: new Date(),
              key: "selection",
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(
          `${baseAPI}userget/GetDashboardUsersLeadData?option=${filterUserData}&startDate=&endDate=`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setUsersLeadCount(response.data.data);
            setColorsUsers(generateColorsUsers(response.data.data));
            setTotalAssignedLeads(response.data.totalAssignedLeads);
            setTotalUsers(response.data.totalUsers);
            setTotalLeadUpdate(response.data.totalLeadUpdate);
            setTotalTargetAchieved(response.data.totalTargetAchieved);
            setTotalRevenue(response.data.totalRevenue);
            setTotalConversion(response.data.totalConversion);
            setTotalRevConversion(response.data.totalRevConversion);
            setTotalQuotationAmount(response.data.totalQuotation);
            setTotalTokenAmount(response.data.tokenAmount);
            setTotalSalesTarget(response.data.totalSalesTarget); 
            setTotalRevenueAchieved(response.data.totalRevenueAchieved);
            setTotalLeadConversionTarget(response.data.totalLeadConversionTarget);
            setTotalLeadsAchieved(response.data.totalLeadsAchieved);
            setTotalLeadAchievedPer(response.data.totalLeadAchievedPer);
            setSelectionRangeUser({
              startDate: new Date(),
              endDate: new Date(),
              key: "selection",
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });        
    }
  }, []);

  useEffect(() => {
    const fetchFilteredResults = async () => {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.get(
        `${baseAPI}userget/GetDashboardLeadStage?option=${filterData}&startDate=&endDate=`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      if (response && response.data && response.data.data) {
        setFilteredResults(response.data.data);
        setColors(generateColors(response.data.data));
        setTotalRecords(response.data.totalRecords);
        setSelectionRange({
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        });
      }
    };

    fetchFilteredResults();
  }, []);

  // Function to generate dynamic colors
  function generateColors(data) {
    const colorMapping = {};
    data.forEach((item, index) => {
      colorMapping[item.StageName] =
        "#" + Math.floor(Math.random() * 16777215).toString(16);
    });
    return colorMapping;
  }

  function generateColorsSource(data) {
    const colorMapping = {};
    data.forEach((item) => {
      colorMapping[item.LeadSource] =
        "#" + Math.floor(Math.random() * 16777215).toString(16);
    });
    return colorMapping;
  }

  function generateColorsUsers(data) {
    const colorMapping = {};
    data.forEach((item, index) => {
      const randomColor =
        "#" + (((1 << 24) * Math.random()) | 0).toString(16).padStart(6, "0");
      colorMapping[item.name] = randomColor;
    });
    return colorMapping;
  }

  const handleFilterUserChange = (event) => {
    setFilterUserData(event.target.value);
  };

  const handleFilterChange = (event) => {
    setFilterData(event.target.value);
  };

  const closeFilterLeadStage = () => {
    setLeadStagePickerOpen(!isLeadStagePickerOpen);
  };

  const closeButtonLeadSource = () => {
    setLeadSourcePickerOpen(!isLeadSourcePickerOpen);
  };

  const closeButtonLeadCountUser = () => {
    setIsUserLeadDataOpen(!isUserLeadDataOpen);
  };

  const leadStageApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    let cdate = formatDate(new Date());
    let startdate = selectionRange.startDate
      ? formatDate(selectionRange.startDate)
      : "";
    let enddate = selectionRange.endDate
      ? formatDate(selectionRange.endDate)
      : "";

    if (startdate === cdate && enddate === cdate) {
      setDateRangeStage("Select Date Range");
      startdate = '';
      enddate = '';

    } else {
      setDateRangeStage(startdate + " - " + enddate);
    }


    toggleLeadStagePicker();
    if (isLeadStagePickerOpen) {
      setLeadStagePickerOpen(!isLeadStagePickerOpen);
    } else {
      setLeadStagePickerOpen(isLeadStagePickerOpen);
    }

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetDashboardLeadStage?option=${filterData}&startDate=${startdate}&endDate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response && response.data && response.data.data) {
            setFilteredResults(response.data.data);
            setColors(generateColors(response.data.data));
            setTotalRecords(response.data.totalRecords);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const leadSourceApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = selectionRangeSource.startDate
      ? formatDate(selectionRangeSource.startDate)
      : "";
    let enddate = selectionRangeSource.endDate
      ? formatDate(selectionRangeSource.endDate)
      : "";

    if (startdate && enddate) {
      setDateRangeSource(startdate + " - " + enddate);
    } else {
      setDateRangeSource("Select Date Range");
    }

    setLeadSourcePickerOpen(false);

    if (storedToken) {
      setLoading(true);
      axios
        .get(
          `${baseAPI}userget/GetDashboardLeadSource?startDate=${startdate}&endDate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          if (response && response.data && response.data.data) {
            setLeadSources(response.data.data);
            setTotalLeadSource(response.data.totalRecords);
            setColorsSource(generateColorsSource(response.data.data));
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const userLeadApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    let cdate = formatDate(new Date());
    let startdate = selectionRangeUser.startDate
      ? formatDate(selectionRangeUser.startDate)
      : "";
    let enddate = selectionRangeUser.endDate
      ? formatDate(selectionRangeUser.endDate)
      : "";

    if (startdate === cdate && enddate === cdate) {
      setDateRangeUser("Select Date Range");
      startdate = '';
      enddate = '';

    } else {
      setDateRangeUser(startdate + " - " + enddate);
    }

    setIsUserLeadDataOpen(false);

    if (storedToken) {
      setLoading(true);
      axios
        .get(
          `${baseAPI}userget/GetDashboardUsersLeadData?option=${filterUserData}&startDate=${startdate}&endDate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          if (response && response.data && response.data.data) {
            setUsersLeadCount(response.data.data);
            // setTotalLeadSource(response.data.totalRecords);
            setColorsUsers(generateColorsUsers(response.data.data));
            setTotalAssignedLeads(response.data.totalAssignedLeads);
            setTotalUsers(response.data.totalUsers);
            setTotalLeadUpdate(response.data.totalLeadUpdate);
            setTotalTargetAchieved(response.data.totalTargetAchieved);
            setTotalRevenue(response.data.totalRevenue);
            setTotalConversion(response.data.totalConversion);
            setTotalRevConversion(response.data.totalRevConversion);
            setTotalQuotationAmount(response.data.totalQuotation);
            setTotalTokenAmount(response.data.tokenAmount);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const [selectionRangeSource, setSelectionRangeSource] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });

  const [selectionRangeUser, setSelectionRangeUser] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });

  const toggleLeadStagePicker = () => {
    setLeadStagePickerOpen(!isLeadStagePickerOpen);
    if (isLeadSourcePickerOpen || isUserLeadDataOpen) {
      setLeadSourcePickerOpen(false);
      setIsUserLeadDataOpen(false);
    }
  };

  const toggleLeadSourcePicker = () => {
    setLeadSourcePickerOpen(!isLeadSourcePickerOpen);
    if (isLeadStagePickerOpen || isUserLeadDataOpen) {
      setLeadStagePickerOpen(false);
      setIsUserLeadDataOpen(false);
    }
  };

  const toggleLeadCountUser = () => {
    setIsUserLeadDataOpen(!isUserLeadDataOpen);
    if (isLeadStagePickerOpen || isLeadSourcePickerOpen) {
      setLeadStagePickerOpen(false);
      setLeadSourcePickerOpen(false);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }
  const handleSelectLeadSource = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectionRangeSource({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
  };

  const handleSelectleadUser = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectionRangeUser({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
  };

  const handleSelectLeadStage = (ranges) => {

    setSelectionRange({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
      key: "selection",
    });
  };

  const COLORS = {
    WhatsApp: "#3366CC",
    IVR: "#DC3912",
    "Web Query": "grey",
    Email: "#FF9900",
    Admin: "#109618",
    Staff: "#990099",
    Reference: "red",
    Tawk: "pink",
    "Web Contact Us": "aqua",
    "Web Contact Us Page": "Violet",
  };

  const data1 = [
    { name: "Lead Assigned", value: totalAssignedLeads },
    { name: "Conversions", value: totalTargetAchieved },
    { name: "Conversion", value: totalConversion}
  ];

  const colors1 = {
    "Lead Assigned": "#EDEDED",
    Conversions: "#49A84C",
  };

    const data2 = [
          { name: "Sales Target", value: totalSalesTarget },
          { name: "Revenue Achieved", value: totalRevenueAchieved },
          { name: "Revenue Achieved %", value: totalRevConversion },
        ];

  const colors2 = {
    "Sales Target": "#EDEDED",
    "Revenue Achieved": "#A3519F",
  };

  const data3 = [
    { name: "Lead Conversion Target", value: totalLeadConversionTarget },
    { name: "Leads Achieved", value: totalLeadsAchieved },
    { name: "Lead Achieved", value: totalLeadAchievedPer}
  ];

  const colors3 = {
    "Lead Conversion Target": "#EDEDED",
    "Leads Achieved": "#5B489D",
  };


  const getConversionColor = (percentage) => {
    if (percentage < 66) return "red";
    if (percentage >= 66 && percentage < 100) return "orange";    
    return "green";
  };

  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc"); // Default sort order is ascending

  const sortAndToggleOrder = (column) => {
    // Determine the new sort order
    const newSortOrder =
      sortedColumn !== column || sortOrder === "desc" ? "asc" : "desc";

    let sortedData = [...usersLeadCount];
    // Sorting logic here (adjusted to use newSortOrder)
    if (column === "assigned_leads") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "lead_update") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "target_achieved") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "conversions") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    }else if (column === "quotation_amount") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    }else if (column === "token_amount") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    }
     else if (column === "revenue") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "revenue_percentage") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    }

    setUsersLeadCount(sortedData);
    setSortedColumn(column);
    setSortOrder(newSortOrder);
  };

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid wholeContainer"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            ></div>

            <div>
              <div className="datattat" style={{ width: "100%" }}>
                <LeadData />
              </div>

        

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "30px",
                  paddingBottom: "30px",
                }}
              >
                <div className="container" style={{ width: "50%" }}>
                  <Wrapper className="pieChart">
                    <div className="outerFilterLeadStage">
                      {/* Filter for lead stage */}
                      <div className="innerFilterLead">
                        <div className="filter-icon-stage">
                          <img
                            src={require("../../../Icons/filterIcon.png")}
                            alt="filter"
                          />
                          FILTER
                        </div>

                        <div style={{ paddingRight: "6px" }}>
                          <button
                            style={{
                              marginBottom: "1rem",
                              width: "10rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "11px",
                            }}
                            onClick={toggleLeadStagePicker}
                          >
                            {" "}
                            <b> {dateRangeStage}</b>
                          </button>
                          {isLeadStagePickerOpen && (
                            <div
                              style={{
                                position: "absolute",
                                zIndex: 999,
                                border: "solid 1px black",
                                marginLeft: "-5pc",
                                width: "35pc",
                                background: "white",
                              }}
                            >
                              <DateRangePicker
                                ranges={[selectionRange]}
                                onChange={handleSelectLeadStage}
                              />
                              <button
                                onClick={leadStageApplyButton}
                                style={{
                                  marginBottom: "1rem",
                                  width: "8rem",
                                  height: "2.5rem",
                                  borderRadius: "0.5rem",
                                  fontSize: "13px",
                                  position: "relative",
                                  top: "1px",
                                  left: "16pc",
                                  backgroundColor: "#5B489D",
                                  color: "White",
                                  border: "none",
                                }}
                              >
                                Apply Filter
                              </button>
                              <button
                                onClick={closeFilterLeadStage}
                                style={{
                                  marginBottom: "1rem",
                                  width: "7.5rem",
                                  height: "2.5rem",
                                  borderRadius: "0.5rem",
                                  fontSize: "13px",
                                  position: "relative",
                                  top: "1px",
                                  left: "17pc",
                                  color: "red",
                                  backgroundColor: "white",
                                  border: "none",
                                  fontWeight: "bold",
                                }}
                              >
                                Close
                              </button>
                            </div>
                          )}
                        </div>
                        <div style={{ paddingRight: "6px" }}>
                          <select
                            style={{
                              marginBottom: "1rem",
                              width: "6rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              fontWeight: "bold",
                            }}
                            name="filterdata"
                            value={filterData}
                            onChange={handleFilterChange}
                          >
                            {/* <option value="">Status</option> */}
                            <option value="0">All</option>
                            <option value="1">Open</option>
                            <option value="2">Closed</option>
                          </select>
                        </div>
                        <div>
                          <button
                            style={{
                              width: "5rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "12px",
                              backgroundColor: "#5B489D",
                              color: "white",
                              fontWeight: "bold",
                            }}
                            onClick={leadStageApplyButton}
                          >
                            Apply
                          </button>
                        </div>
                      </div>

                      <div className="leadStageListButton">
                        <p>
                          {" "}
                          <b> Total: </b>{" "}
                          <span style={{ color: "#5B489D" }}>
                            <b>{totalRecords}</b>
                          </span>
                        </p>
                      </div>
                    </div>

                    <hr style={{ width: "95%", marginLeft: "2%" }} />
                    <h3
                      style={{
                        fontSize: "25px",
                        padding: "9px",
                        fontWeight: "700",
                        color: "#6A6A6A",
                      }}
                    >
                      Lead Stage
                    </h3>
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "55%",
                          display: "flex",
                          marginLeft: "1%",
                        }}
                      >
                        <PieChartComponentLeadStage
                          data={filteredResults}
                          colors={colors}
                        />
                      </div>
                      <div className="Lead_stagetable">
                        <table style={{ width: "17.5rem" }}>
                          <hr />
                          {filteredResults.map((item, index) => (
                            <tr
                              style={{ borderBottom: "1px solid #ccc" }}
                              key={index}
                            >
                              <td>
                                <ul>
                                  <span
                                    style={{
                                      color: colors[item.StageName],
                                      fontWeight: "bold",
                                    }}
                                  >
                                    &#9679;
                                  </span>{" "}
                                  {item.StageName}
                                </ul>
                              </td>
                              <td>{item.total_count}</td>
                            </tr>
                          ))}
                        </table>
                      </div>
                    </div>
                  </Wrapper>
                </div>
                <div className="container" style={{ width: "50%" }}>
                  <Wrapper className="pieChart">
                    <div className="outerFilterLeadStage">
                      <div className="outerFilter">
                        <div className="filter-icon-source">
                          <img
                            src={require("../../../Icons/filterIcon.png")}
                            alt="filter"
                          />
                          FILTER
                        </div>

                        <div style={{ paddingRight: "6px" }}>
                          <button
                            style={{
                              marginBottom: "1rem",
                              width: "8rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "11px",
                            }}
                            onClick={toggleLeadSourcePicker}
                          >
                            {" "}
                            <b> {dateRangeSource}</b>
                          </button>
                          {isLeadSourcePickerOpen && (
                            <div
                              style={{
                                position: "absolute",
                                zIndex: 999,
                                border: "solid 1px black",
                                marginLeft: "-13pc",
                                width: "35pc",
                                background: "white",
                              }}
                            >
                              <DateRangePicker
                                ranges={[selectionRangeSource]}
                                onChange={handleSelectLeadSource}
                              />

                              <button
                                onClick={leadSourceApplyButton}
                                style={{
                                  marginBottom: "1rem",
                                  width: "8rem",
                                  height: "2.5rem",
                                  borderRadius: "0.5rem",
                                  fontSize: "13px",
                                  position: "relative",
                                  top: "1px",
                                  left: "17pc",
                                  backgroundColor: "#5B489D",
                                  color: "White",
                                  border: "none",
                                }}
                              >
                                Apply Filter
                              </button>
                              <button
                                onClick={closeButtonLeadSource}
                                style={{
                                  marginBottom: "1rem",
                                  width: "7.5rem",
                                  height: "2.5rem",
                                  borderRadius: "0.5rem",
                                  fontSize: "13px",
                                  position: "relative",
                                  top: "1px",
                                  left: "17pc",
                                  color: "red",
                                  backgroundColor: "white",
                                  border: "none",
                                  fontWeight: "bold",
                                }}
                              >
                                Close
                              </button>
                            </div>
                          )}
                        </div>

                        <div>
                          <button
                            style={{
                              width: "9rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "12px",
                              backgroundColor: "#5B489D",
                              color: "white",
                              fontWeight: "bold",
                            }}
                            onClick={leadSourceApplyButton}
                          >
                            Apply
                          </button>
                        </div>
                      </div>

                      <div className="leadSourceListButton">
                        <p>
                          {" "}
                          <b> Total: </b>{" "}
                          <span style={{ color: "#5B489D" }}>
                            <b>{totalLeadSource}</b>
                          </span>
                        </p>
                      </div>
                    </div>
                    <hr style={{ background: "red" }} />

                    <h3
                      style={{
                        fontSize: "25px",
                        padding: "9px",
                        fontWeight: "700",
                        color: "#6A6A6A",
                      }}
                    >
                      Lead Source
                    </h3>
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          marginLeft: "0%",
                        }}
                      >
                        <PieChartComponent
                          data={leadSources}
                          colors={colorsSource}
                        />
                      </div>
                      <div
                        className="Lead_stagetable"
                        style={{ marginLeft: "10px" }}
                      >
                        <table style={{ width: "17.5rem" }}>
                          <hr />

                          {leadSources.map((item, index) => (
                            <tr
                              style={{ borderBottom: "1px solid #ccc" }}
                              key={index}
                            >
                              <td>
                                <ul>
                                  <span
                                    style={{
                                      color: colorsSource[item.LeadSource],
                                      fontWeight: "bold",
                                    }}
                                  >
                                    &#9679;
                                  </span>{" "}
                                  {item.LeadSource}
                                </ul>
                              </td>
                              <td>{item.CountOfRelocation_ID}</td>
                            </tr>
                          ))}
                        </table>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>

              <div className="userPieChart wrapper">
                <div className="outerFilterLeadUser">
                  <div className="innerFilterLeadUser">
                    <div className="filter-icon-stage-user">
                      <img
                        src={require("../../../Icons/filterIcon.png")}
                        alt="filter"
                      />
                      FILTER
                    </div>

                    <div style={{ paddingRight: "6px" }}>
                      <button
                        style={{
                          marginBottom: "1rem",
                          width: "10rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "11px",
                        }}
                        onClick={toggleLeadCountUser}
                      >
                        {" "}
                        <b> {dateRangeUser}</b>
                      </button>
                      {isUserLeadDataOpen && (
                        <div
                          style={{
                            position: "absolute",
                            zIndex: 999,
                            border: "solid 1px black",
                            marginLeft: "-5pc",
                            width: "35pc",
                            background: "white",
                          }}
                        >
                          <DateRangePicker
                            ranges={[selectionRangeUser]}
                            onChange={handleSelectleadUser}
                          />
                          <button
                            onClick={userLeadApplyButton}
                            style={{
                              marginBottom: "1rem",
                              width: "8rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              position: "relative",
                              top: "1px",
                              left: "16pc",
                              backgroundColor: "#5B489D",
                              color: "White",
                              border: "none",
                            }}
                          >
                            Apply Filter
                          </button>
                          <button
                            onClick={closeButtonLeadCountUser}
                            style={{
                              marginBottom: "1rem",
                              width: "7.5rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              position: "relative",
                              top: "1px",
                              left: "17pc",
                              color: "red",
                              backgroundColor: "white",
                              border: "none",
                              fontWeight: "bold",
                            }}
                          >
                            Close
                          </button>
                        </div>
                      )}
                    </div>
                    <div style={{ paddingRight: "6px" }}>
                      <select
                        style={{
                          marginBottom: "1rem",
                          width: "6rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold",
                        }}
                        name="filterUserdata"
                        value={filterUserData}
                        onChange={handleFilterUserChange}
                      >
                        <option value="1">Active</option>
                        <option value="0">InActive</option>
                        <option value="2">All</option>
                        <option value="3">Others</option>
                      </select>
                    </div>
                    <div>
                      <button
                        style={{
                          width: "5rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "12px",
                          backgroundColor: "#5B489D",
                          color: "white",
                          fontWeight: "bold",
                        }}
                        onClick={userLeadApplyButton}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>

                <hr style={{ background: "red" }} />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {/* <div>
                    <h3
                      style={{
                        fontSize: "25px",
                        padding: "9px",
                        fontWeight: "700",
                        color: "#6A6A6A",
                      }}
                    >
                      Users
                    </h3>
                    <br />
                  </div> */}
                  {/* <div style={{ display: "flex" }}> */}
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        marginLeft: "1%",
                        marginTop: "-1%",
                        justifyContent: "space-around",
                        marginBottom:"23px"
                      }}
                    >
                      {/* <TwoLevelPieChartUsers
                        data01={data01}
                        data02={data02}
                        colors={colorsUsers}
                      /> */}
                      <PieChartConversions data={data1} colors={colors1} />
                      <PieChartRevenueAchieved data={data2} colors={colors2} />
                      <PieChartLeadAchieved data={data3} colors={colors3} />
                    </div>
                    <div className="container-fluid">
                      <div className="usersorderSummary">
                        <table style={{ width: "100%", textAlign: "center" }}>
                          <thead className="stickyheader">
                            <tr className="orderSummaryHeading_dashboard">
                              <th>Name</th>
                              <th
                                onClick={() =>
                                  sortAndToggleOrder("assigned_leads")
                                }
                              >
                                Assigned Leads{" "}
                                {sortedColumn === "assigned_leads" && (
                                  <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                                )}
                              </th>
                              <th
                                onClick={() =>
                                  sortAndToggleOrder("lead_update")
                                }
                              >
                                Leads Update{" "}
                                {sortedColumn === "lead_update" && (
                                  <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                                )}
                              </th>
                              <th
                                onClick={() =>
                                  sortAndToggleOrder("target_achieved")
                                }
                              >
                                Total Conversions{" "}
                                {sortedColumn === "target_achieved" && (
                                  <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                                )}
                              </th>
                              <th
                                onClick={() =>
                                  sortAndToggleOrder("conversions")
                                }
                              >
                                Conversion (%){" "}
                                {sortedColumn === "conversions" && (
                                  <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                                )}
                              </th>
                              <th
                                onClick={() =>
                                  sortAndToggleOrder("quotation_amount")
                                }
                              >
                                Quotation Amount{" "}
                                {sortedColumn === "quotation_amount" && (
                                  <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                                )}
                              </th>
                              <th
                                onClick={() =>
                                  sortAndToggleOrder("token_amount")
                                }
                              >
                                Token Amount{" "}
                                {sortedColumn === "token_amount" && (
                                  <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                                )}
                              </th>
                              <th onClick={() => sortAndToggleOrder("revenue")}>
                                Execution Amount{" "}
                                {sortedColumn === "revenue" && (
                                  <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                                )}
                              </th>
                              <th
                                onClick={() =>
                                  sortAndToggleOrder("booking_percentage")
                                }
                              >
                                Booking (%){" "}
                                {sortedColumn === "booking_percentage" && (
                                  <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="assignedLeads-ayu">
                            {usersLeadCount.map((user, index) => (
                              <tr key={index}>
                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      src={icon_user} // Assuming `user.imageUrl` is the path to the user's image
                                      alt={user.name}
                                      style={{
                                        height: "1rem",
                                        width: "1rem",
                                        marginRight: "10px", // Spacing between the image and the name
                                        objectFit: "cover", // This will ensure the image covers the area without distortion
                                      }}
                                    />
                                    <div style={{ width: "120px" }}>
                                      {user.name}
                                    </div>
                                  </div>
                                </td>

                                <td>{user.assigned_leads}</td>
                                <td>{user.lead_update}</td>
                                <td>{user.target_achieved}</td>

                                <td>
                                  <div
                                    style={{
                                      width: "92px",
                                      height: "35px",
                                      borderRadius: "29px",
                                      backgroundColor: getConversionColor(
                                        user.conversions
                                      ),
                                      color: "white",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginLeft: "20%",
                                    }}
                                  >
                                    {user.conversions} %
                                  </div>
                                </td>
                                <td>{user.quotation_amount}</td>
                                <td>{user.token_amount}</td>

                                <td>{user.revenue}</td>
                                <td>
                                  <div
                                    style={{
                                      width: "92px",
                                      height: "35px",
                                      borderRadius: "29px",
                                      backgroundColor: getConversionColor(
                                        user.booking_percentage
                                      ),
                                      color: "white",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginLeft: "20%",
                                    }}
                                  >
                                    {user.booking_percentage} %
                                  </div>
                                </td>
                                <hr />
                              </tr>
                            ))}
                          </tbody>
                          <thead className="stickyheader1">
                            <tr className="orderSummaryHeading_dashboard1">
                              <th style={{ textAlign: "left" }}>
                                Total &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                                {totalUsers}
                              </th>
                              <th>{totalAssignedLeads}</th>
                              <th>{totalLeadUpdate}</th>
                              <th>{totalTargetAchieved}</th>
                              <th>{totalConversion}</th>
                              <th>{totalQuotationAmount}</th>
                              <th>{totalTokenAmount}</th>
                              <th>{totalRevenue}</th>
                              <th>{totalRevConversion}</th>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  {/* </div> */}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "30px",
                  paddingBottom: "30px",
                }}
              >
                <div className="container" style={{ width: "60%" }}>
                  <Wrapper className="userMap">
                    <MapComponent />
                  </Wrapper>
                </div>
                <div className="container" style={{ width: "40%" }}>
                  <Wrapper className="barGraphData">
                    <Graph />
                  </Wrapper>
                </div>
              </div>

              {/* <br /> 
               <OrderSummary />
              <br />  */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
